module.exports = __webpack_public_path__ + "img/flv.b2d2bb35.svg";